import type { FC, ReactElement } from 'react';

import { useModifiers } from '../../../styles/hooks/useModifiers';
import { IconButton, IconButtonSize } from '../../controls/iconButton/IconButton';

import styles from './NavBurger.module.css';

export interface NavBurgerPlainProps {
  navControlsCondition: boolean;
  onClick: () => void;
  isGhost?: boolean;
  isLarge?: boolean;
  isOpen?: boolean;
  isOverlaid?: boolean;
  isSmall?: boolean;
  navControls?: ReactElement;
  navOpen?: boolean;
}

export const NavBurger: FC<NavBurgerPlainProps> = ({
  isGhost,
  isLarge,
  isOpen,
  isOverlaid,
  isSmall,
  navControls,
  navControlsCondition,
  navOpen,
  onClick,
}): ReactElement => {
  const containerMods = useModifiers(styles, 'nav__burgerContainer', { open: isOpen }, { withBaseClass: true });
  const mods = useModifiers(styles, 'navBurger', { open: navOpen, overlaid: isOverlaid }, { withBaseClass: true });
  let buttonSize: IconButtonSize = IconButtonSize.REGULAR;

  if (isLarge) {
    buttonSize = IconButtonSize.LARGE;
  } else if (isSmall) {
    buttonSize = IconButtonSize.SMALL;
  }

  return (
    <div className={containerMods}>
      {/* TODO: Understand why and comment*/}
      {navControlsCondition ? <div className={styles.nav__controls}>{navControls}</div> : ''}
      <div data-testid="nav-burger" className={mods}>
        <IconButton size={buttonSize} ghost={isGhost} onClick={onClick}>
          <div className={styles.navBurger__icon}>
            <div className={styles.navBurger__icon__line} />
            <div className={styles.navBurger__icon__line} />
            <div className={styles.navBurger__icon__line} />
          </div>
        </IconButton>
      </div>
    </div>
  );
};
